import { message } from 'antd';
import { PROMOCODE } from '../../../api/apiPaths';
import { post,get } from '../../../api/commonAPI';
import * as Actions from './CreatePromoCodeActionTypes';
import toastr from 'toastr';

export const createPromoCode = (promoCodeData, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      type: Actions.CREATE_PROMO_CODE
    });

    post(PROMOCODE, promoCodeData)
      .then(res => {
        dispatch({
          type: Actions.CREATE_PROMO_CODE_SUCCESS,
          payload: res.data
        });
        toastr.success('Promo code created successfully!');

        if (onSuccess) onSuccess(res.data);

      })
      .catch(error => {
        dispatch({
          type: Actions.CREATE_PROMO_CODE_FAILS,
          payload: error
        });
        
        const errorMessage = error.response?.data?.errors?.[0] || 'Failed to create promo code';
        toastr.error(errorMessage);
        if (onError) onError(error);

      });
  };
};

// for list promo codes
export const getPromoCodes = () => {
    return dispatch => {
      dispatch({
        type: Actions.FETCH_PROMO_CODES
      });
      
      get(PROMOCODE)
        .then(res => {
          dispatch({
            type: Actions.FETCH_PROMO_CODES_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_PROMO_CODES_FAILS,
            payload: error
          });
          
          const errorMessage = error.response?.data?.errors?.[0] || 'Failed to fetch promo codes';
          toastr.error(errorMessage);
        });
    };
  };

// export const getPromoCodes = () => {
//     return dispatch => {
//       dispatch({
//         type: Actions.FETCH_PROMO_CODES
//       });
      
//       // Use mock data if flag is set
//      if (USE_MOCK_DATA) {
//       return new Promise(resolve => {
//         setTimeout(() => {
//           // Dispatch the mock data
//           dispatch({
//             type: Actions.FETCH_PROMO_CODES_SUCCESS,
//             payload: mockPromoCodesData
//           });
//           resolve(mockPromoCodesData);
//         }, 800); 
//       });
//     }
      
//       // return get(PROMOCODE)
//       //   .then(res => {
//       //     dispatch({
//       //       type: Actions.FETCH_PROMO_CODES_SUCCESS,
//       //       payload: res.data
//       //     });
//       //   })
//       //   .catch(error => {
//       //     dispatch({
//       //       type: Actions.FETCH_PROMO_CODES_FAILS,
//       //       payload: error
//       //     });
          
//       //     const errorMessage = error.response?.data?.errors?.[0] || 'Failed to fetch promo codes';
//       //     toastr.error(errorMessage);
//       //   });
//     };
//   };